import { JSX, useContext, useEffect, useState } from "react"
import Logo from "./Logo"
import LangSwitcher from "./LangSwitcher";
import Footer from "./Footer";

export default function Container(props: { children: JSX.Element }) {
    return (
        <div className="w-full min-h-full bg-gray-50">
            <div className="min-h-[90vh]">
                <div className="hidden md:block absolute left-[5%] md:left-[10%] md:pt-[106px] z-10">
                    <LangSwitcher />
                </div>
                <Logo />
                <main className="mx-auto max-w-[1280px] pt-[32px] md:pt-[40px] w-full px-[24px] md:px-[16px] pb-[50px] md:pb-[120px]">
                    {props.children}
                </main >
            </div >
            <Footer />
        </div>
    )
}